import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IVw_Zilla {
zilla_id:number,
zilla_name:string,
vibhag_id:number,
seq_no:number,
is_active:boolean,
vibhag_name:string
}

interface IVw_ZillaData {
    list?: Array<IVw_Zilla>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IVw_ZillaData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const vw_zillaSlice = createSlice({
    name: "vw_zilla",
    initialState,
    reducers: {
        setVw_ZillaList: (state, _action: PayloadAction<IVw_ZillaData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetVw_ZillaToInit: (state) => {
            state = initialState;
        },
        setVw_ZillaMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setVw_ZillaList, resetVw_ZillaToInit, setVw_ZillaMessage } = vw_zillaSlice.actions;

export default vw_zillaSlice.reducer;

